import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  EDIT_USER_DETAILS,
  USER_DETAILS,
  GUEST_USER,
  VIEW_USER_PERSONAL_DETAILS,
} from "../SagaAction/actions";
import {
  updatedUserPersonalDetailsRequest,
  updatedUserPersonalDetailsSuccess,
  updatedUserPersonalDetailsFailure,
  addGuestUserDetailsRequest,
  addGuestUserDetailsSuccess,
  addGuestUserDetailsFailure,
  userViewProfileDetailsRequest,
  userViewProfileDetailsFailure,
  userViewProfileDetailsSuccess,
} from "../Slices/UserSlice";
import requestApi from "../../utils/request";

function* updatedPersonalDetail(params) {
  try {
    yield put(updatedUserPersonalDetailsRequest());
    const data = yield requestApi.post("edit-profile", params.payload);
    // console.log("getUserDetailSuccess",data);
    yield put(updatedUserPersonalDetailsSuccess(data));
  } catch (e) {
    yield put(updatedUserPersonalDetailsFailure(e));
  }
}


function* viewUserPersonalDetails(params) {
  try {
    yield put(userViewProfileDetailsRequest());
    const { data } = yield requestApi.post("view-profile", params.payload);
    yield put(userViewProfileDetailsSuccess(data));
  } catch (e) {
    yield put(userViewProfileDetailsFailure(e));
  }
}

function* userSaga() {
  yield takeLatest(EDIT_USER_DETAILS, updatedPersonalDetail);
  yield takeLatest(VIEW_USER_PERSONAL_DETAILS, viewUserPersonalDetails);
}

export default userSaga;
